import { render, staticRenderFns } from "./DialogRecord.vue?vue&type=template&id=735b4a6e"
import script from "./DialogRecord.vue?vue&type=script&lang=js"
export * from "./DialogRecord.vue?vue&type=script&lang=js"
import style0 from "./DialogRecord.vue?vue&type=style&index=0&id=735b4a6e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports